module.exports = __webpack_public_path__ + "media/images/connectedDataReport-7b4d0218c2f602d0fe11a2638aa3e175189ff3a0eaf8ed321864166d5a23644f.svg";